import { useEffect, useRef } from "react";

// Lot 661 — « remonter / actualiser » façon Facebook : Retour Android sur le fil, onglet actif retapé, logo (PC).
// 1er geste quand la page est descendue → remonte ; geste déjà en haut → la page actualise.
// La mémoire de position (ancre du fil / des profils au retour d'un post) n'est pas touchée.
const TOP_THRESHOLD = 120;
const EVENT = "yalola:refresh-page";

export const isAtTop = () => (window.scrollY || 0) <= TOP_THRESHOLD;
// Lot 740 — remontée = saut DIRECT en haut, une seule image, rien ne défile devant les yeux (décision owner : « un
// appui, saut direct en haut », comme Facebook). Remplace les lots 687/713/738 (saut à 2 écrans + glisse animée +
// pré-montage des cartes) : la glisse traversait des cartes démontées par le fil fenêtré → « plusieurs publications
// qui reviennent bizarrement ». Ancrage de défilement coupé et haut maintenu quelques images, le temps que les cartes du
// haut se remontent (sinon le moteur repousse la page vers le bas). Un geste du membre interrompt. Renvoie l'arrêt.
export const TOP_HOLD_FRAMES = 24;
const raf = (fn) => (typeof requestAnimationFrame === "function" ? requestAnimationFrame(fn) : setTimeout(fn, 16));
const caf = (id) => { try { if (typeof cancelAnimationFrame === "function") cancelAnimationFrame(id); else clearTimeout(id); } catch { /* noop */ } };
export const scrollToTop = () => {
  if ((window.scrollY || 0) <= 0) return () => {};
  const roots = [document.documentElement, document.body].filter(Boolean);
  const prevAnchor = roots.map((r) => r.style.overflowAnchor);
  roots.forEach((r) => { r.style.overflowAnchor = "none"; });
  const evs = ["touchstart", "wheel", "pointerdown"];
  let id = 0, stopped = false, hold = 0;
  const finish = () => {
    if (stopped) return;
    stopped = true;
    caf(id);
    roots.forEach((r, i) => { r.style.overflowAnchor = prevAnchor[i] || ""; });
    evs.forEach((e) => window.removeEventListener(e, finish));
  };
  evs.forEach((e) => window.addEventListener(e, finish, { passive: true }));
  const step = () => {
    if (stopped) return;
    window.scrollTo({ top: 0, behavior: "instant" });
    if (hold++ < TOP_HOLD_FRAMES) { id = raf(step); return; }
    finish();
  };
  step();
  return finish;
};
export const requestRefresh = () => window.dispatchEvent(new CustomEvent(EVENT));

// Renvoie "top" (remontée faite) ou "refresh" (déjà en haut → actualisation demandée à la page).
export const topOrRefresh = () => {
  if (!isAtTop()) { scrollToTop(); return "top"; }
  requestRefresh();
  return "refresh";
};

// Les pages qui savent s'actualiser (fil, profil…) s'abonnent ; `fn` toujours la dernière version.
export const useRefreshOnDemand = (fn) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const h = () => ref.current?.();
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, []);
};
